const sellcarPageConfig = {
  role: true,
  title: "Sell Your Car",
  subtitle: "Please provide accurate information about your vehicle",
  roleSection: {
    title: "Select Your Role",
    subtitle: "Choose how you'd like to list your vehicle",
    continueLabel: "Continue",
  },
  imageSection: {
    uploadLabel: "Upload Car Images",
    addMoreLabel: "+ Add More Images",
    mainAlt: "main",
    thumbAlt: "thumb",
    accept: "image/*",
    multiple: true,
  },
  actions: {
    draftLabel: "Save Draft",
    submitLabel: "Submit",
    submittingTitle: "Submitting Listing",
    submittingMessage: "Please wait while we save your vehicle details",
    submittingInline: "Submitting...",
  },
  selectMessages: {
    default: "Select {label}",
    selectBrandFirst: "Select Brand First",
    selectStateFirst: "Select State First",
    selectCityFirst: "Select City First",
  },
  validation: {
    requiredMessage: "Please fill in all required fields",
    failedTitle: "Validation Failed",
    fieldRequired: "{label} is required",
    minValue: "{label} must be at least {min}",
    maxValue: "{label} must be at most {max}",
    locationRequired: "Please select a location on the map",
    successTitle: "Listing Submitted",
    successMessage: "Your car listing has been submitted successfully",
    draftTitle: "Draft Saved",
    draftMessage: "Your listing draft has been saved",
  },
  errors: {
    loginRequiredTitle: "Login required",
    loginRequiredMessage: "Please log in to submit your listing",
    submissionFailedTitle: "Submission failed",
    submissionFailedMessage: "Could not save listing",
    draftFailedTitle: "Draft failed",
    draftFailedMessage: "Could not save draft",
  },
  routes: {
    login: "/login",
    afterSubmit: "/profile",
  },
  map: {
    is_show: true,
    label: "Pick Location on Map",
    hint: "Click anywhere on the map to pin your location",
    selectedLabel: "Selected Location",
    defaultCenter: { lat: 13.0827, lng: 80.2707 },
    defaultZoom: 12,
    tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
  roles: [
    {
      id: 1,
      name: "Owner",
      value: "owner",
      icon: "🚗",
      description: "I am selling my own personal vehicle",
    },
    {
      id: 2,
      name: "Agent",
      value: "agent",
      icon: "🤝",
      description: "I am listing a vehicle on behalf of a client",
    },
  ],
};

export default sellcarPageConfig;
